export default () => {
  return {
    active: [],
    list: []
  }
}
